import { render, staticRenderFns } from "./SaleContract.vue?vue&type=template&id=8dee5354"
import script from "./SaleContract.vue?vue&type=script&lang=js"
export * from "./SaleContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports